import { Fragment } from "react";
import { LoginForm } from "./loginForm";
import { useAuth } from "../../Context/AuthContext";
import { SuspenseLoader } from "../../Layout/Common/loader";
import { Link, Navigate } from "react-router-dom";
import { PAGES } from "../../routeConfig";

export const LoginFormContainer = () => {
  const { isAuthenticated, authLoading } = useAuth();
  if (authLoading) {
    return <SuspenseLoader />;
  } else if (isAuthenticated) return <Navigate to="/home" replace />;
  else
    return (
      <Fragment>
        <div className="loginwrapper" style={{ display: "block" }}>
          <div id="loginNew" className="container-fluid container-lg">
            <div className="row">
              <div className="col-md-12 col-lg-10 offset-lg-1">
                <div className="loginInner-wrapper">
                  <div className="row">
                    <div className="col-md-7">
                      <div className="login-content login-contentPage" style={{ height: "100%" }}>
                        <div className="loginModal-popup">
                          <div className="loginModal-header text-center">
                            <h5>Welcome. Please Login</h5>
                            <p className="fw-normal col-fs-13 fs-14">Enter below details to continue your account</p>
                          </div>
                          <LoginForm />
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="loginCreateAccount">
                        <h5>Sign Up for a Trade Account</h5>
                        <h6 className="mt-4">Unlock Trade Benefits</h6>
                        <p className="fs-14 fw-light mt-4">
                          Premium Audio, AV, Data, Electronics, and Electrical products from top brands. Fast nationwide
                          shipping, Sydney trade counter pickup, 24/7 online ordering, multi-user account management,
                          and trade-only pricing. Sign up now - quick and easy!
                        </p>
                        <div className="button-effect">
                          <Link to={PAGES.SIGNUP} className="btn btn-products btn-addcart">
                            Create an Account
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
};
